import React from 'react'
import { Formik, Form } from 'formik';
import { MainInput, SubmitButton } from '../../components';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../application/utils/Routes';
import services from '../../../ioc/services';
import { useDispatch, useSelector } from 'react-redux';
import { getFormSubmittingState } from '../../../application/store/selectors/ui';
import { setFormSubmitting } from '../../../application/store/actions/ui';

function ChangePasswordForm() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const isFormSubmiting = useSelector(getFormSubmittingState);

    return (
        <div className="w-full max-w-lg  mx-auto">
            <h1 className=' text-center mb-8 font-bold text-2xl'>Change Password</h1>
            <Formik
                initialValues={{}}
                enableReinitialize
                onSubmit={async (values) => {

                    if (!values.oldPassword) {
                        services.alert.toast.error("Please Enter Your Old Password")
                        return
                    }

                    if (!values.newPassword) {
                        services.alert.toast.error("Please Enter Your New Password")
                        return
                    }

                    if (!values.confirmNewPassword) {
                        services.alert.toast.error("Please Confirm Your New Password")
                        return
                    }

                    if (values.newPassword !== values.confirmNewPassword) {
                        services.alert.toast.error("Passwords Do Not Match")
                        return
                    }

                    dispatch(setFormSubmitting(true))

                    services.api.auth.changePassword(values)
                        .then(res => {
                            services.alert.toast.success("Password Changed Successfully")
                            navigate(ROUTES.DASHBOARD)

                        })
                        .catch(err => {
                            services.alert.toast.error(err);
                        })
                        .finally(() => {
                            dispatch(setFormSubmitting(false))
                        })

                }}>
                <Form className="flex flex-col gap-7 mx-auto">
                    <MainInput label="Old Password" name="oldPassword" type="password" placeholder="" />
                    <MainInput label="New Password" name="newPassword" type="password" placeholder="" />
                    <MainInput label="Confirm New Password" name="confirmNewPassword" type="password" placeholder="" />
                    <SubmitButton text="Change Password" disabled={isFormSubmiting} />
                </Form>

            </Formik>



        </div>
    )
}

export default ChangePasswordForm